import React from 'react'
import BrandLogo from '../../components/Brand/BrandLogo'
import { brand } from '../../config/settings/brand'
import AuthPreviewCarousel from './AuthPreviewCarousel'
import {
  Shell,
  FormColumn,
  FormInner,
  BrandRow,
  BrandName,
  BrandPanel,
  BrandPanelContent,
  BrandPanelEyebrow,
  BrandPanelHeadline,
  BrandPanelSupport,
  BrandPanelPreview,
  BrandPanelGlow,
} from './AuthShell.styles'

/**
 * Split-screen auth shell: centered form + product preview carousel on large screens.
 */
const AuthSplitLayout = ({
  children,
  brandEyebrow = brand.name,
  brandHeadline = brand.tagline,
  brandSupport,
  showPreview = true,
}) => {
  return (
    <Shell>
      <FormColumn>
        <FormInner>
          <BrandRow>
            <BrandLogo size={36} />
            <BrandName>{brand.name}</BrandName>
          </BrandRow>
          {children}
        </FormInner>
      </FormColumn>

      <BrandPanel>
        <BrandPanelGlow />
        <BrandPanelContent>
          {brandEyebrow ? (
            <BrandPanelEyebrow>{brandEyebrow}</BrandPanelEyebrow>
          ) : null}
          {brandHeadline ? (
            <BrandPanelHeadline>{brandHeadline}</BrandPanelHeadline>
          ) : null}
          {brandSupport ? (
            <BrandPanelSupport>{brandSupport}</BrandPanelSupport>
          ) : null}
          {showPreview ? (
            <BrandPanelPreview>
              <AuthPreviewCarousel />
            </BrandPanelPreview>
          ) : null}
        </BrandPanelContent>
      </BrandPanel>
    </Shell>
  )
}

export default AuthSplitLayout
